"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigData = void 0;
const axios_1 = __importDefault(require("axios"));
const getConfigData = (schoolId) => __awaiter(void 0, void 0, void 0, function* () {
    const newApi = `schools/${schoolId}/config`;
    const oldApi = `config/${schoolId}`;
    try {
        const response = yield axios_1.default.get(`${process.env.REACT_APP_API_URL}/${newApi}`);
        return response.data;
    }
    catch (primaryError) {
        try {
            const fallbackResponse = yield axios_1.default.get(`${process.env.REACT_APP_API_URL}/${oldApi}`);
            return fallbackResponse.data;
        }
        catch (fallbackError) {
            return null;
        }
    }
});
exports.getConfigData = getConfigData;
